/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetDashboardOverviewParams = zod.object({
	start: zod.string(),
	end: zod.string(),
	praetor_id: zod.string().optional(),
	grain: zod.string().optional()
});

export type GetDashboardOverviewParams = zod.input<typeof GetDashboardOverviewParams>;
export type GetDashboardOverviewParamsOutput = zod.output<typeof GetDashboardOverviewParams>;
